(() => {
  if (window.risuonoNavigationReady) return;
  window.risuonoNavigationReady = true;
  const roots = () => document.querySelectorAll('[data-risuono-menu]');
  const close = (root) => {
    root.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
    if (root.matches('details')) root.removeAttribute('open');
  };
  document.addEventListener('click', (event) => {
    roots().forEach((root) => {
      if (!root.contains(event.target) || event.target.closest('a')) close(root);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest('[data-risuono-menu]');
    if (!root) return;
    const trigger = root.querySelector('summary');
    close(root);
    trigger?.focus();
  });
  document.addEventListener('toggle', (event) => {
    const root = event.target;
    if (!root.matches('.risuono-mobile-nav')) return;
    root.querySelector(':scope > summary').setAttribute('aria-label', root.open ? 'Chiudi il menu' : 'Apri il menu');
  }, true);
  window.matchMedia('(min-width: 990px)').addEventListener('change', () => roots().forEach(close));
})();
